<template>
  <div class="mathStockyard" ref="mathStockyard">
    <div class="divPadding" @click="toShed">
      <div class="profile" v-if="introduction.mediaUrl">
        <img
          v-if="
            introduction.mediaUrl.toLowerCase().indexOf('jpg') != -1 ||
            introduction.mediaUrl.toLowerCase().indexOf('png') != -1
          "
          :src="introduction.mediaUrl"
        />
        <video
          v-else
          muted="muted"
          autoplay
          loop="loop"
          controls
          :src="introduction.mediaUrl"
        ></video>
      </div>
      <div class="profile" v-else><img src="./img/angang.jpg" /></div>
      <div
        class="text"
        :style="{ color: styleType == 'typeGreen' || darkStyle ? '#fff' : '#9bc0f0' }"
      >
        <marquee width="100%" height="168px" direction="up" scrollamount="2">
          {{ introduction.mediaDesc }}
        </marquee>
      </div>
    </div>
    <a class="toShed" style="display: none" href="unityShed://hello">去往数字化料场</a>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import videoPopup from "./component/videoPopup.vue";
import Detail from "./component/detail.vue";
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'mathStockyard.vue',
      computedName: '数字孪生环保料场组件',
      customerId: this.$store.state.customerId,
      introduction: { mediaDesc: "" },
      styleType: "",
    };
  },
  components: {
    Detail,
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
    this.darkStyle = bmeConfig.darkStyle;
  },
  mounted() {
    let w = $(this.$refs.mathStockyard).outerWidth();
    let h = $(this.$refs.mathStockyard).outerHeight();
    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });

    this.getAbouts();
  },
  methods: {
    async getAbouts() {
      let medias = CONFIG.requestName + this.$apiOpt.medias;
      let data = await this.$apiUtils.get(medias, {
        customerId: this.customerId,
        // customerId: 57,
      });
      this.introduction = data && data[0];
    },
    showHtml(str) {
      //富文本解析
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&amp;nbsp;/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    },
    popupVideoWin() {
      if (this.introduction?.mediaUrl) {
        this.$store.commit("dialogStatus", true);
        this.$popup.open(
          videoPopup,
          this.dialogCompontent,
          {},
          {
            videoUrl: this.introduction.mediaUrl,
          }
        );
      }
    },
    toShed() {
      let a = document.getElementsByClassName("toShed");
      let button = a[0];
      console.log("button", button);
      button.click();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.mathStockyard {
  width: 600px;
  height: 250px;
  .divPadding {
    display: flex;
    justify-content: space-between;
    padding-top: 40px;
    .profile {
      padding: 5px;
      // width: 290px;
      // height: 170px;
      @include bg-box(290px, 170px, "profileBg.png");
      // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
      box-sizing: border-box;
      img {
        height: 100%;
        width: 100%;
      }
      video {
        height: 100%;
        width: 100%;
      }
    }
    .text {
      height: 168px;
      width: 50%;
      padding-left: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #9bc0f0;
      line-height: 25px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
